export const SET_EXAM_RULES = 'SET_EXAM_RULES'
